import React from "react";
import Loader from "../../Components/Loader";
import editIcon from "../../Assets/Icons/edit.png";
import deleteIcon from "../../Assets/Icons/delete.png";
import downArrow from "../../Assets/Icons/chevron-down.png";
import NatureExpenseForm from "../Components/AddExpenseTypeModal";
import DeleteConfirmationModal from "../../Components/Modals/DeleteConformationModal";
import useNatureExpenseController from "../Controllers/ManageNatureOfExpenseController";

const ManageNatureOfExpenseList = () => {
  const {
    natureTypes,
    loading,
    error,
    isModalOpen,
    isDeleteModalOpen,
    handleAddNew,
    handleEdit,
    handleDelete,
    deleteLoading,
    deleteError,
    deleteSuccess,
    natureInfoRef,
    handleCloseModal,
    handleCloseDeleteModal,
    confirmDelete,
    currentPage,
    totalPages,
    handlePageChange,
    visiblePages,
    currentNatureTypes,
    onValueChange,getStatusStyle
  } = useNatureExpenseController();

  return (
    <div className="basic-info-container">
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: 10, alignItems: "center" }}>
        <h3 style={styles.header}>Expense Types</h3>
        <button className="add-client-button" style={{ paddingLeft: 30, paddingRight: 30 }} onClick={handleAddNew}>
          Add New
        </button>
      </div>

      <div style={styles.tableWrapper}>
        <table className="tasksScreen-task-table">
          <thead>
            <tr>
              <th style={{width:'25%'}}>Nature of Expense</th>
              <th style={{width:'45%'}}>Description</th>
              <th style={{width:'10%'}}>Created By</th>
              <th style={{width:'10%'}}>Status</th>
              <th style={{width:'10%'}}></th>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white" }}>
            {currentNatureTypes?.map((item, index) => (
              <tr key={index}>
                <td style={styles.tableLink}>{item?.name}</td>
                <td style={styles.tableValue}>{item?.description || "--"}
                {deleteError[item?.id] && <div className="list-error-msg">{deleteError[item?.id]}</div>}
                {deleteSuccess[item?.id] && <div className="list-success-msg">{deleteSuccess[item?.id]}</div>}
                </td>
                <td style={styles.tableValue}>{item.created_by_name}</td>
                <td style={styles.tableValue}>
                  <div
                    style={{
                      display: "inline-block",
                      padding: "5px 10px",
                      borderRadius: "15px",
                      width: "auto",
                      fontSize: "12px",
                      ...getStatusStyle(item?.status),
                    }}
                  >
                    {item?.status ? 'Active':'Disabled'}
                  </div>
                </td>
                <td>
                  <div style={{ display: "flex", gap: "5px" }}>
                    <button onClick={() => handleEdit(item)} 
                    style={{...styles.iconBtn,opacity: deleteLoading[item.id] ? 0.3 : 1}} 
                    disabled={deleteLoading[item.id]}>
                      <img src={editIcon} alt="Edit" style={styles.iconImage} />
                    </button>
                    <button
                      onClick={() => handleDelete(item)}
                      disabled={deleteLoading[item.id]}
                      style={{...styles.iconBtn,opacity: deleteLoading[item.id] ? 0.3 : 1}}
                    >
                      <img src={deleteIcon} alt="Delete" style={styles.iconImage} />
                    </button>
                    {deleteLoading[item.id] && <Loader loading={true} color="#000" size="small" />}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {loading && <Loader loading={loading} color="var(--primary-loader-color)" />}
        {error && <div className="list-error-msg">{error}</div>}
      </div>

      {/* Pagination */}
      <div className="tasksScreen-table-footer">
        <span className="tasksScreen-pagination-info">{`${currentPage} - ${totalPages} of items`}</span>
        <div className="tasksScreen-pagination">
          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1 || totalPages === 0}
          >
            <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image" />
          </button>

          {visiblePages.map((page) => (
            <button
              key={page}
              className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          ))}

          <button
            className="tasksScreen-pagination-button"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image" />
          </button>
        </div>
      </div>

      {/* Modals */}
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        message={`Are you sure you want to delete ${natureInfoRef.current?.name}?`}
        onClose={handleCloseDeleteModal}
        onConfirm={() => {
          handleCloseDeleteModal();
          confirmDelete(natureInfoRef.current);
        }}
      />

      {isModalOpen && (
        <NatureExpenseForm
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          editData={natureInfoRef.current}
          onValueChange={onValueChange}
        />
      )}
    </div>
  );
};

const styles = {
  header: {
    color: "#1F384C",
    fontSize: 28,
    fontFamily: "Roboto Slab",
    fontWeight: 500
  },
  tableWrapper: {
    overflowX: "auto",
    whiteSpace: "nowrap",
    marginBottom: 50
  },
  tableLink: {
    fontSize: "12px",
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#5A55D2"
  },
  tableValue: {
    fontSize: "12px",
    fontFamily: "Roboto",
    color: "#192A3E"
  },
  iconBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer"
  },
  iconImage: {
    width: 16,
    height: 16
  }
};

export default ManageNatureOfExpenseList;
